import { LoaderFunction, redirect } from 'react-router';
import { t } from 'i18next';
import { authService } from '~/services/auth/auth-service';
import { createRoutes } from '~/routes';

export const forgotPasswordConfirmLoader: LoaderFunction = async ({
  request,
}) => {
  const url = new URL(request.url);
  const oobCode = url.searchParams.get('oobCode');

  if (!oobCode) {
    return redirect(createRoutes.ForgotPassword);
  }

  try {
    await authService.verifyPasswordResetCode(oobCode);
  } catch {
    throw new Error(
      t('createNewPassword.errors.invalidOrExpiredCode' as const),
    );
  }

  return null;
};
